export enum EntityUpdateType {
  MANUAL = 'MANUAL',
  AI = 'AI',
  AI_AGENT = 'AI_AGENT',
  HYBRID = 'HYBRID',
}
